export const CHANGE_VOLUME = 'change.volume';

export const PAUSE_VIDEO = 'pause.video';

export const EXPAND_TIME = 'expand.time';

export const PARTICIPANT_STATUS = 'participant.status';

export const SET_MIC_OR_VIDEO = 'set.mic.or.video';

export const HANDLE_QUITE_MODE_POPUP = 'handleQuiteModePopup';

export const DEFAULT_MODE = 'defaultMode';

export const PATIENT_HAS_PAUSE = 'patient_has_pause';

export const PATIENT_HAS_QUIET = 'patient_has_quiet';

export const HANDLE_OFF_MODE_OPEN = 'HANDLE_OFF_MODE_OPEN';

export const HANDLE_OFF_MODE_HIDE = 'HANDLE_OFF_MODE_HIDE';

export const PATIENT_HAS_OFF_MODE = 'PATIENT_HAS_OFF_MODE';
